import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { activityLogService } from '../services/activityLogService';

export const getActivitiesByCase = createAsyncThunk(
  'activityLog/getActivitiesByCase',
  async ({ caseId, options }, { rejectWithValue }) => {
    try {
      const response = await activityLogService.getActivitiesByCase(caseId, options);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const activityLogSlice = createSlice({
  name: 'activityLog',
  initialState: {
    activities: [],
    summary: null,
    loading: false,
    error: null,
  },
  reducers: {
    // ✅ NEW: Clear state when component closes
    clearActivities: (state) => {
      state.activities = [];
      state.summary = null;
      state.loading = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActivitiesByCase.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActivitiesByCase.fulfilled, (state, action) => {
        state.loading = false;
        state.activities = action.payload;
      })
      .addCase(getActivitiesByCase.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const { clearActivities, clearError } = activityLogSlice.actions;

export default activityLogSlice.reducer;
